import { render } from "./hero.vue?vue&type=template&id=c1cf87b2&scoped=true"
import script from "./hero.vue?vue&type=script&lang=js"
export * from "./hero.vue?vue&type=script&lang=js"

import "./hero.vue?vue&type=style&index=0&id=c1cf87b2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c1cf87b2"

export default script